import type { DEVICE_TYPE } from '../../../components/StatelessComponent/SingleFilter/DeviceTypeFilter/DeviceFilterType';
import { DEVICE_FILTER_OPTIONS } from '../../../components/StatelessComponent/SingleFilter/DeviceTypeFilter/DeviceFilterType';
import { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../LabelFormatterType';
import { getLabels as shortListLabelFormatterGetLabels } from './GenericLabelFormatter/ShortListLabelFormatter';

export function getLabels(currentValue?: DEVICE_TYPE[]): LabelProps {
  return shortListLabelFormatterGetLabels(currentValue, FilterKindEnum.DeviceType, {
    optionList: DEVICE_FILTER_OPTIONS,
  });
}
